import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TaxonomyCategory } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { TaxonomyCategoryService } from '../../services/taxonomy-category.service';

@Component({
  selector: 'app-taxonomy-category-drop-down',
  imports: [],
  template: '',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxonomyCategoryDropDownComponent extends GenericBaseModelDropDown<TaxonomyCategory> {

  constructor(private service: TaxonomyCategoryService) {
    super(service, "TaxonomyCategory");
  }

}
